export default __webpack_public_path__ + "static/media/3G.d12b188c.png";